import type { EmbarcacaoDetailExportButtonProps } from "./types-embarcacao-detail-export-button";
import { useEmbarcacaoDetailExportButton } from "./use-embarcacao-detail-export-button";
import { EmbarcacaoDetailExportButtonView } from "./view-embarcacao-detail-export-button";

export function EmbarcacaoDetailExportButton(props: EmbarcacaoDetailExportButtonProps) {
  const vm = useEmbarcacaoDetailExportButton(props);

  return <EmbarcacaoDetailExportButtonView {...vm} />;
}

export type * from "./types-embarcacao-detail-export-button";
